import { TrackingIds } from '@innovation-os-ng/core/core';

export const TRACKING_IDS: TrackingIds = {
  // Adding an element to the casual search
  U6TokXlwOL63XP6: {
    eventAction: 'Add',
    eventCategory: 'Element',
    eventLabel: 'Casual Search'
  },
  // Clicking on power search to expand it
  e2Vi26KKE6HBpHm: {
    eventAction: 'Expand',
    eventCategory: 'Power Search',
    eventLabel: 'Search Field Header'
  },
  // Hitting enter on power search
  g6LMmtDiSxmz3dj: {
    eventAction: 'Initiate',
    eventCategory: 'Search',
    eventLabel: 'Power Search'
  },
  // Adding a value to a context property
  pj8rH5i7DnwlUJJ: {
    eventAction: 'Add',
    eventCategory: 'Value',
    eventLabel: 'Context Input'
  },
  // Adding a property to the context UI
  wIoXJvss0XhG3EV: {
    eventAction: 'Add',
    eventCategory: 'Context Input',
    eventLabel: 'Search Field Header'
  },
  // Removing a property from the context UI
  RokebF0rddGyYB6: {
    eventAction: 'Remove',
    eventCategory: 'Context Input',
    eventLabel: 'Search Field Header'
  },
  // Clicking on Save
  UaEDwixASLWhNoG: {
    eventAction: 'Update',
    eventCategory: 'Saved Search Field',
    eventLabel: 'Saved Search Field Picker'
  },
  // Clicking on Save As…
  WI5kNvxFWP94mN6: {
    eventAction: 'Initiate Create',
    eventCategory: 'Search Field',
    eventLabel: 'Saved Search Field Picker'
  },
  // Actually saving a search field
  Y72Tsljqk7RzFro: {
    eventAction: 'Create',
    eventCategory: 'Search Field',
    eventLabel: 'Modal'
  },
  // Adding items to the attached elements of a saved search field
  qM95y5yMlvRndNG: {
    eventAction: 'Add',
    eventCategory: 'Element',
    eventLabel: 'Saved Search Field'
  },
  // Clicking on Discard Changes (if exists…)
  mby9hxrWwPBqJzT: {
    eventAction: 'Reset',
    eventCategory: 'Search Field',
    eventLabel: 'Search Field Header'
  },
  // Choosing a saved search field
  WDNcICBfbGXoEvn: {
    eventAction: 'Select',
    eventCategory: 'Saved Search Field',
    eventLabel: 'Saved Search Field Picker'
  },
  // Clicking the pen icon on a saved search field
  nkiwysH24wd4578: {
    eventAction: 'Initiate Edit',
    eventCategory: 'Saved Search Field',
    eventLabel: 'Saved Search Field Picker'
  },
  // Actually updating a saved search field
  GRqtnKVBmYvuAnR: {
    eventAction: 'Edit',
    eventCategory: 'Saved Search Field',
    eventLabel: 'Modal'
  },
  // Clicking the bin icon on the saved search field
  kCtIIW7zA7c3u9q: {
    eventAction: 'Initiate Delete',
    eventCategory: 'Saved Search Field',
    eventLabel: 'Saved Search Field Picker'
  },
  // Actually deleting a saved search field
  VUHKvYakWlUikea: {
    eventAction: 'Delete',
    eventCategory: 'Saved Search Field',
    eventLabel: 'Saved Search Field Picker'
  },
  // Switching visualizations
  HcbiJ9Lxpo00XhU: {
    eventAction: 'Change',
    eventCategory: 'Main Visualization',
    eventLabel: 'Main Visualization Tabs'
  },
  // Changing the Group By field
  xkhE7Vj1Q8IfGGL: {
    eventAction: 'Change',
    eventCategory: 'Time Chart Visualization',
    eventLabel: 'Grouping'
  },
  // Toggling Normalization option
  Weddl5VDMKfGGO2: {
    eventAction: 'Change',
    eventCategory: 'Time Chart Visualization',
    eventLabel: 'Normalization'
  },
  // Toggling the different options (Bubbles, Shading, …)
  K9L5wMKZ6ymCUSi: {
    eventAction: 'Change',
    eventCategory: 'World Map Visualization',
    eventLabel: 'Options Panel'
  },
  // Reset view
  VQ32UiEi01NoWCg: {
    eventAction: 'Reset',
    eventCategory: 'World Map Visualization',
    eventLabel: 'Toolbar'
  },
  // Zooming in
  Y4ZJHkw5OGdb5Mf: {
    eventAction: 'Dive In',
    eventCategory: 'Cluster Visualization',
    eventLabel: 'Bubble'
  },
  // When zoomed in, using the x next to the bubbles label to zoom all the way out again
  g05gASdJ6V5S05b: {
    eventAction: 'Dive Out',
    eventCategory: 'Cluster Visualization',
    eventLabel: 'Bubble Label'
  },
  // Reset View
  Ybk7XKZvCYO3P6d: {
    eventAction: 'Reset',
    eventCategory: 'Cluster Visualization',
    eventLabel: 'Toolbar'
  },
  // Adding a custom option
  bT47TUYe1AC4Njw: {
    eventAction: 'Add',
    eventCategory: 'Custom Bar',
    eventLabel: 'Bar Chart'
  },
  // Selection from bar chart
  k86mB7DwSQfP13X: {
    eventAction: 'Add',
    eventCategory: 'Selection',
    eventLabel: 'Bar Chart'
  },
  // Selection from world map
  YIbZfGlr4gXmaTq: {
    eventAction: 'Add',
    eventCategory: 'Selection',
    eventLabel: 'World Map Visualization'
  },
  // Selection from timeline chart
  KfGsqwLZLh4qT1N: {
    eventAction: 'Add',
    eventCategory: 'Selection',
    eventLabel: 'Time Chart Visualization'
  },
  // Selection from cluster visualization
  l6JjnBLn8v1msDW: {
    eventAction: 'Add',
    eventCategory: 'Selection',
    eventLabel: 'Cluster Visualization'
  },
  // Remove Selection from  bar chart (“x”)
  meekxHQ9vkgnood: {
    eventAction: 'Remove',
    eventCategory: 'Selection',
    eventLabel: 'Bar Chart'
  },
  // Remove Selection from selection panel
  j7O81OGAyZznEaz: {
    eventAction: 'Remove',
    eventCategory: 'Selection',
    eventLabel: 'Selection Panel'
  },
  // Remove Selection from one of the timeline chart
  BAWP8VEDHwfz4Er: {
    eventAction: 'Remove',
    eventCategory: 'Selection',
    eventLabel: 'Time Chart Visualization'
  },
  // Remove Selection from world map
  TuIrtqmo1BbLYno: {
    eventAction: 'Remove',
    eventCategory: 'Selection',
    eventLabel: 'World Map Visualization'
  },
  // Remove Selection from cluster
  mufuFEojW5dxOVu: {
    eventAction: 'Remove',
    eventCategory: 'Selection',
    eventLabel: 'Cluster Visualization'
  }
};

// Tracked actions (needs to be prefixed with `insights.<section>.`)
export enum TrackedActions {
  CLOSE_FROM_PANEL = 'closeFromPanel',
  DESELECT_ALL = 'deselectAll',
  DESELECT_ITEM = 'deselectItem',
  OPEN_DROPDOWN = 'openDropdown',
  SEARCH = 'search',
  SEARCH_IN_DROPDOWN = 'searchInDropdown',
  SELECT_ITEM = 'selectItem',
  TAB_CLICKED = 'TabClicked',
  VALUE_SELECTED = 'valueSelected',
  VALUE_DESELECTED = 'valueDeselected'
}

// Tracked event IDs
export enum TrackedEvents {
  ADD_FILTER_DROPDOWN_OPENED = 'insights.filtersTab.addFilterDropdownOpened',
  ADD_FILTER_PANEL_FROM_BUTTON = 'insights.filtersTab.addFilterPanel',
  AGGREGATION_TIMEOUT_RETRY = 'insights.aggregation.timeoutRetry',
  AGGREGATION_TIMEOUT_RETRY_NOTIFICATION = 'insights.aggregation.timeoutRetryNotification',
  AGGREGATION_TIMEOUT_ERROR = 'insights.aggregation.timeoutError',
  AGGREGATION_TIMEOUT_ERROR_NOTIFICATION = 'insights.aggregation.timeoutErrorNotification',
  APPLY_CONTEXT_FROM_CREATED_ELEMENT = 'insights.header.applyContextFromCreatedElement',
  CASUAL_SEARCH_ADD = 'insights.casualSearch.add',
  CLOSE_FILTER_SETTINGS = 'insights.header.closeFilterSettings',
  CLUSTER_SLIDER_USED = 'insights.clusterViz.topicsSliderUsed',
  CLUSTER_ZOOM_IN = 'insights.clusterViz.zoomIn',
  CLUSTER_ZOOM_OUT = 'insights.clusterViz.zoomOut',
  CREATE_MODAL_FROM_HEADER = 'insights.header.openCreateElementModal',
  CREATE_MODAL_FROM_SIGNAL = 'createModalFromSignal',
  DATE_SELECT_RANGE = 'insights.dateFilter.selectRange',
  DOC_TYPE_DESELECT = 'insights.filterWidget.deselectDocumentType',
  DOC_TYPE_SELECT = 'insights.filterWidget.selectDocumentType',
  FILTER_CLEAR = 'insights.filterPresets.clear',
  FILTER_CREATE = 'insights.filterPresets.create',
  FILTER_DELETE = 'insights.filterPresets.delete',
  FILTER_DELETE_INITIATE = 'insights.filterPresets.initiateDelete',
  FILTER_DESELECT_ASSOCIATED = 'insights.filterPresets.deselectAssociatedElement',
  FILTER_DISCARD_CHANGES = 'insights.filterPresets.discardChanges',
  FILTER_SAVE = 'insights.filterPresets.save',
  FILTER_SAVE_INITIATE = 'insights.filterPresets.initiateSaveAs',
  FILTER_SELECT_ASSOCIATED = 'insights.filterPresets.selectAssociatedElement',
  FILTER_UPDATE = 'insights.filterPresets.update',
  FILTER_DROPDOWN_CLOSE_CHANGED = 'insights.filterDropdown.closeWithChanges',
  FILTER_DROPDOWN_SEARCH = 'insights.filterDropdown.search',
  FILTER_DROPDOWN_SELECT_ALL = 'insights.filterDropdown.selectAll',
  FILTER_DROPDOWN_SELECT_ITEM = 'insights.filterDropdown.selectItem',
  FILTER_WIDGET_DESELECT_BAR = 'insights.filterWidget.deselectItemBar',
  FILTER_PRESET_CIRCULAR_DEPENDENCE = 'insights.presetFilterWidget.circularlyDependentSelected',
  FILTER_WIDGET_SHOW_MORE = 'insights.filterWidget.showMore',
  FILTER_WIDGET_SHOW_LESS = 'insights.filterWidget.showLess',
  HEADER_SETTINGS = 'insights.header.openFilterSettings',
  NEWSFEED_BLOCK_SIGNAL = 'insights.signalsFeed.blockSignal',
  NEWSFEED_UNBLOCK_SIGNAL = 'insights.signalsFeed.unblockSignal',
  POWER_SEARCH_TOGGLE = 'insights.powerSearch.toggle',
  POWER_SEARCH_SEARCH = 'insights.powerSearch.search',
  PANEL_CLOSE_FROM_WARNING = 'insights.filterPanel.closeFromWarning',
  PANEL_RESET_FROM_WARNING = 'insights.filterPanel.resetFromWarning',
  PREFIX_DATE_FILTER = 'insights.dateFilter',
  PREFIX_FILTER_DRODPOWN = 'insights.filterDropdown',
  PREFIX_FILTER_PRESET = 'insights.filterPresets',
  PREFIX_MAIN = 'insights.main',
  PREFIX_SIGNALS_LIST = 'insights.signalsList',
  PREFIX_SIGNALS_STACK = 'insights.signalsStack',
  PREFIX_VIZ = 'insights.visualization',
  PREFIX_WORLDMAP_TYPE = 'insights.worldmap.type',
  RELATE_ELEMENT_CREATED_FROM_SIGNAL = 'relateElementCreatedFromSignal',
  RESET_GLOBAL_FILTERS = 'insights.resetGlobalFilters',
  SIG_LIST_TAG_CLICK = 'insights.signalsList.tagClicked',
  SIG_STACK_TAG_CLICKED = 'insights.signalsStack.tagClicked',
  SSF_SEARCH = 'insights.SSFWidget.search',
  SSF_SELECT = 'insights.SSFWidget.select',
  SSF_CLOSE_PANEL = 'insights.SSFWidget.closeFromPanel',
  TIMELINE_GROUP_BY = 'insights.timeline.groupBy',
  TIMELINE_NORMALIZE = 'insights.timeline.toggleNormalization',
  TOTAL_FEED_UPDATED = 'insights.main.totalFeedResultsUpdated',
  VIEW_CONTEXT_DESELECT = 'insights.viewContext.deselectSearchField',
  VIEW_CONTEXT_DISCARD = 'insights.viewContext.discardChanges',
  VIEW_CONTEXT_OPEN_ELEMENT = 'insights.viewContext.openElementInStack',
  VIEW_CONTEXT_SAVE = 'insights.viewContext.save'
}
